import i18n from '@/utils/i18n';
import React from 'react';
import { Pressable } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  onPress: () => void;
}

export const PricingFilterClearButton: React.FC<Props> = ({ onPress }) => {
  const theme = useTheme();

  return (
    <Pressable
      accessibilityLabel={i18n.t('pricing.filters.clear')}
      accessibilityRole="button"
      onPress={onPress}
    >
      <Typography color={theme.sk.color.text.tertiary} variant="label-md">
        {i18n.t('pricing.filters.clear')}
      </Typography>
    </Pressable>
  );
};
